import './styles/atom.less';
import './styles/global.less';
import './styles/arco.less';
import './styles/theme.less';

import { Message, Modal } from '@arco-design/web-vue';
import * as Sentry from '@sentry/vue';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { initDeviceId, loggerInit, initScroll } from './common/utils/initialize';
import { initTheme } from './common/utils';
import vAutoScroll from './directive/scroll';
import { pid } from '@bigo/logger';

import App from './App.vue';
import i18n, { loadLang } from './i18n';
import router from './router';
import { useAppStore } from './store/app';
import { initTestToken } from './debug/helpers';

dayjs.extend(utc);
dayjs.extend(isBetween);

const pinia = createPinia();
const app = createApp(App);

Message._context = app._context;
Modal._context = app._context;

app.use(pinia);
app.use(router);
app.use(i18n);
app.directive('auto-scroll', vAutoScroll);

initDeviceId();
loggerInit();
initScroll();
loadLang();

// 初始化 PartyHero 主题
initTheme();

if (process.env.NODE_ENV === 'development') {
  initTestToken();
}

// 引入Sentry
if (import.meta.env.PROD) {
  const tagMap = {
    actName: 'act.name', // 活动名称
    pid: 'pid', // 日志使用的pid
  };
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_BUILD_VERSION,
    environment: import.meta.env.VITE_BUILD_ENV,
    tracesSampleRate: 1,
    beforeSend(event) {
      event.user = useAppStore().loginUser;
      return event;
    },
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    initialScope: {
      tags: {
        [tagMap.actName]: 'bigolive-agent-oss-front',
        [tagMap.pid]: pid,
      },
    },
  });

  window.DEBUG_SENTRY = (error, ctx) => {
    Sentry.captureException(error || new Error('Debug Sentry'), ctx);
  };
}

app.mount('#app');

// 引入调试工具（开发环境、测试环境）
if (import.meta.env.VITE_BUILD_ENV === 'dev' || import.meta.env.VITE_BUILD_ENV === 'test') {
  import('./debug');
}
